<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left py-3">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Gastos y Compras</h2>
          <p class="text-purple-manax pl-3 subtitle-section">
            Gastos y Compras incluidos en tus Servicios y/o Proyectos.
          </p>
        </span>

        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortExpenses($event)" stickyHeader
          stickyFooter>
          <thead class="text-manax">
            <tr>
              
              <!-- PC -->
              <th class="p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all" />
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top">Concepto</th>

              <!-- Fecha -->
              <th class="d-none d-md-table-cell align-top" style="height: 90px; position: relative; width: 180x;">
                Fecha<br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.expensesDateStart"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 120px; position: absolute; top: 37px; left: 0px;" /><br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.expensesDateEnd"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 120px; position: absolute; top: 60px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">Cliente</th>
              <th class="d-none d-md-table-cell align-top">Proveedor</th>
              <th class="d-none d-md-table-cell align-top">Trabajo</th>
              <th class="d-none d-md-table-cell align-top">Proyecto</th>
              <th class="d-none d-md-table-cell align-top text-right">Total</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let expense of expenses" [class.text-danger]="expense.isDeleted" class="cursor-pointer">
              <!-- Selección -->
              <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(expense._id)"
                      [checked]="selection.all || selection[expense._id || '']" />
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- Concepto -->
              <td>{{ expense.expenses?.detail}}</td>

              <!-- Fecha -->
              <td>{{ expense.expenses?.date | date: 'dd/MM/yyyy' }}</td>

              <!-- Cliente -->
              <td>{{ expense.client?.corporatename || expense.client?.firstname || 'Sin Asignar' }}</td>

              <!-- Proveedor -->
              <td>{{ expense.vendor?.name || 'Sin Asignar' }}</td>

              <!-- Trabajo -->
              <td>{{ expense.title ? expense.title + ' (' + expense.category?.name + ')' : expense.category?.name
                || 'Sin Asignar' }}</td>

              <!-- Proyecto -->
              <td>{{ expense.project?.name || 'Sin Asignar' }}</td>

              <!-- Total -->
              <td class="text-right">{{ expense.expenses?.total | money: { needSymbol:true } }}</td>
            </tr>

            <!-- Botón para cargar más -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)="loadMore()">
                  + cargar más
                </button>
              </td>
            </tr>

            <!-- Cargando -->
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>

          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ expenses.length }} costos</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>